module.exports = __webpack_public_path__ + "static/img/5bg_4.029f1e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_4.png
// module id = 729
// module chunks = 1